import { render, staticRenderFns } from "./TablaPresupuestosPorGrupo.vue?vue&type=template&id=15127e40"
import script from "./TablaPresupuestosPorGrupo.vue?vue&type=script&lang=js"
export * from "./TablaPresupuestosPorGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports